<template>
  <svg
    width="98px"
    height="54px"
    viewBox="0 0 98 54"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>{{ this.percentage }}% of the goal</title>
    <desc>Created with Sketch. Improved by Felipe</desc>
    <g
      id="Welcome"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <!-- <rect width="98px"  stroke="red" stroke-width="1"  height="54px" /> -->

      <g
        id="Dashboard"
        transform="translate(-213.000000, -253.000000)"
      >
        <g
          id="Stylist"
          transform="translate(56.000000, 120.000000)"
        >
          <g
            id="Group-4"
            transform="translate(160.000000, 135.000000)"
          >
            <text
              id="Total-Sales"
              font-family="Karla-Regular, Karla"
              font-size="8"
              font-weight="normal"
              fill="#000000"
            >
              <tspan
                x="24.052"
                y="28"
              >Total Sales</tspan>
            </text>

            <g
              id="SalesProgressLine"
              fill-rule="nonzero"
              stroke-width="5"
            >
              <path
                d="M0,48 A 45 45 0 0 1 90,48"
                stroke="#979797"
              />
              <path
                :d="endpath()"
                stroke="#004150"
              />
            </g>

            <text
              id="SalesProgressTotal"
              text-anchor="middle"
              x="50%"
              y="51"
              font-family="Karla-Bold, Karla"
              font-size="18"
              font-weight="bold"
              fill="#000000"
            >${{ this.total }}</text>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SalesProgress',
  props: {
    percentage: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    endpath() {
      const alpha = (Math.PI * this.percentage) / 100.0;
      const r = 45.0;
      const x = 45 + r * Math.cos(Math.PI - alpha);
      const y = 48 - r * Math.sin(Math.PI - alpha);
      return `M0,48 A 45 45 0 0 1 ${x}, ${y}`;
    },
  },
};
</script>
